import React from "react";
import { Grid, Header } from "semantic-ui-react";
import CheckboxCard from "./CheckboxCard";

const StepOneCheckbox = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <CheckboxCard Text="Recite verse while listening to Sheikh and looking at Quran" Note="Use notes you created for Tafsir to remember!" Count="10" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <CheckboxCard Text="Recite verse alone and looking at Quran" Note="For reps 6 and up, try to pick up the speed and try to start not looking and see where you get stuck and struggle" Count="10" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <CheckboxCard Text="Recite verse alone and only looking at Quran when you need to" Count="10" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <CheckboxCard Text="Test yourself, must be able to recite verse 3 times in a row without any mistakes" Note="You should be able to read the English translation as well. Also it is good if you can be able to explain the verse to anyone." Count="3" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row textAlign="center">
      <Grid.Column>
        <Header content="Repeat for every verse until you get to around half of the page" />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
export default StepOneCheckbox;